export enum WidgetType {
  Location = 'Location',
  AuthCode = 'AuthCode',
  Payment = 'Payment',
  DeepLink = 'DeepLink',
  CameraConsent = 'CameraConsent',
  Consent = 'Consent',
  BankAccountToken = 'BankAccountToken',
  SystemInfo = 'SystemInfo',
  WifiInfo = 'WifiInfo',
  LaunchUri = 'LaunchUri',
  GenericUI = 'GenericUI',
  PaymentIntegration = 'PaymentIntegration',
}

export interface Widget {
  id: string;
  key: WidgetType;
}
